import React, { useMemo, useState, useEffect } from "react"

//import components
import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Button,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
} from "reactstrap"
import {
  FaEdit,
  FaStreetView,
  FaTelegramPlane,
  FaRegPaperPlane,
} from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/DataTableContainer"
import { fetchPvsKeyword } from "../../../redux/actions/pvs"

const PvsKeywords = () => {
  document.title = "PVS Keywords List | PULA"

  const history = useNavigate()
  const dispatch = useDispatch()

  const pvsState = useSelector(state => state.pvs)
  const fetchPvsKeywordState = useSelector(
    state => state.screens.pvs.fetchPvsKeyword
  )

  const [keywordData, setKeywordData] = useState([])
  const columns = useMemo(
    () => [
      {
        header: "Keyword",
        accessorKey: "keyword",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Slug",
        accessorKey: "slug",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Count",
        accessorKey: "count",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Created At",
        accessorKey: "created_modified_at",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <div>
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() =>
                  history(`/edit-pvs-keyword/${row.enc_pvs_key_id}`)
                }
                title="Edit PVS Keywords"
              >
                <FaEdit />
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    dispatch(fetchPvsKeyword())
  }, [dispatch])

  useEffect(() => {
    if (pvsState && pvsState && Array.isArray(pvsState.keywordList)) {
      setKeywordData(pvsState.keywordList)
    }
  }, [pvsState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="flex-grow-1">
            <h4 className="h4 mb-0 nom-title">PVS Keywords List</h4>
          </div>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={keywordData || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          isAddButton={true}
          buttonClass="btn primary-button"
          buttonName="Add PVS Keywords"
          handleUserClick={() => {
            history("/add-pvs-keyword")
          }}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass=" table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
          noDataMessage={fetchPvsKeywordState.message}
        />
      </div>
    </div>
  )
}

export default PvsKeywords
